import { Routes } from '@angular/router';
import { authGuard, adminGuard, roleGuard } from './core/guards/auth.guard';
import { UserRole } from './shared/models/tournament.model';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadComponent: () => import('./features/auth/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'accept-invitation',
    loadComponent: () => import('./features/auth/accept-invitation/accept-invitation.component').then(m => m.AcceptInvitationComponent)
  },
  {
    path: 'forgot-password',
    loadComponent: () => import('./features/auth/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent)
  },
  {
    path: 'reset-password',
    loadComponent: () => import('./features/auth/reset-password/reset-password.component').then(m => m.ResetPasswordComponent)
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./features/dashboard/dashboard.component').then(m => m.DashboardComponent),
    canActivate: [authGuard]
  },
  {
    path: 'tournaments',
    loadChildren: () => import('./features/tournaments/tournament.routes').then(m => m.TOURNAMENT_ROUTES),
    canActivate: [authGuard]
  },
  {
    path: 'participants',
    loadChildren: () => import('./features/participants/participant.routes').then(m => m.PARTICIPANT_ROUTES),
    canActivate: [authGuard, roleGuard([UserRole.TEAM_MANAGER, UserRole.ORGANIZER, UserRole.ADMIN])]
  },
    {
      path: 'team-applications',
      loadChildren: () => import('./features/team-applications/team-applications.routes')
        .then(m => m.TEAM_APPLICATIONS_ROUTES),
      canActivate: [authGuard, roleGuard([UserRole.TEAM_MANAGER, UserRole.ORGANIZER, UserRole.ADMIN])]
    },
  // 🚀 ADD THE MISSING ADMIN ROUTE:
  {
    path: 'admin',
    loadChildren: () => import('./features/admin/admin.routes').then(m => m.ADMIN_ROUTES),
    canActivate: [authGuard, adminGuard]
  },
  {
    path: 'organizations',
    loadChildren: () => import('./features/organizations/organization.routes').then(m => m.ORGANIZATION_ROUTES),
    canActivate: [authGuard, roleGuard([UserRole.ADMIN, UserRole.ORGANIZER, UserRole.TEAM_MANAGER])]
  },
  {
    path: 'profile',
    loadComponent: () => import('./features/profile/profile.component').then(m => m.ProfileComponent),
    canActivate: [authGuard]
  },
  {
    // Awards desk: no login, tournament desk token in ?t= (40_EVENT_DAY_AND_AWARDS_DESK.md D4)
    path: 'desk/awards',
    loadComponent: () => import('./features/desk/awards-desk/awards-desk.component').then(m => m.AwardsDeskComponent)
  },
  {
    path: 'unauthorized',
    loadComponent: () => import('./features/errors/unauthorized/unauthorized.component').then(m => m.UnauthorizedComponent)
  },
  {
    path: '**',
    redirectTo: '/dashboard'
  }
];


